<script lang="ts">
	import type { ClassValue } from "svelte/elements";
	import logoImage from "@core/assets/images/fathers-logo.svg?raw";
	import Icon from "./common/Icon.svelte";

	const { class: customClass }: { class: ClassValue } = $props();
</script>

<Icon icon={logoImage} class={customClass} />
